import { Button } from '@cimplico/components';
import { useState } from 'react';
import { useIsActiveSubscription } from '../../../../../../hooks/use-is-active-subscription';
import { useFYIConfig } from '../../../../../../queries/use-fyi-config';
import { Cabinet } from '../../../../../../types/fyi-docs';
import FirmFYICredentialsForm from './FirmFYICredentialsForm';
import FirmFYICabinetForm from './FirmFYICabinetForm';

function FirmFYIConfig(): JSX.Element {
    const configQuery = useFYIConfig();
    const [replacingKeys, setReplacingKeys] = useState(false);
    const [editingCabinet, setEditingCabinet] = useState(false);
    const activeSubscription = useIsActiveSubscription();

    if (configQuery.isLoading) {
        return <></>;
    }
    if (configQuery.isError || !configQuery.isSuccess) {
        return <p>Error!</p>;
    }

    if (!configQuery.data.config?.validAccessKeys) {
        return <FirmFYICredentialsForm />;
    }
    if (!configQuery.data.config.cabinet) {
        return (
            <div>
                <p className="text-sm text-gray-600 my-2">Configure your FYI Cabinet to auto-file documents.</p>
                <FirmFYICabinetForm />
            </div>
        );
    }

    const { cabinet } = configQuery.data.config;

    return (
        <div className="mt-4 min-h-[300px]">
            <div>
                <div className="flex items-end justify-between w-full border-b pb-1 mb-2 ">
                    <p className="text-sm font-medium text-gray-900">Details</p>
                    <Button
                        type="secondary"
                        label="Edit"
                        size="sm"
                        onClick={(): void => setEditingCabinet(true)}
                        disabled={!activeSubscription}
                    />
                </div>
                {editingCabinet ? (
                    <FirmFYICabinetForm defaultCabinet={cabinet as Cabinet} onCancel={(): void => setEditingCabinet(false)} />
                ) : (
                    <div>
                        <section>
                            <p className="text-sm text-gray-900 font-medium">Cabinet</p>
                            <p className="text-gray-800 text-sm">{cabinet.name}</p>
                        </section>
                    </div>
                )}
            </div>
            <div className="mt-4">
                <p className="border-b pb-1 mb-2 text-sm font-medium text-gray-900">Access Keys</p>
                {!replacingKeys && (
                    <Button
                        type="secondary"
                        size="sm"
                        label="Replace keys"
                        onClick={(): void => setReplacingKeys(true)}
                        disabled={!activeSubscription}
                    />
                )}
                {replacingKeys && <FirmFYICredentialsForm mode="update" onCancel={(): void => setReplacingKeys(false)} />}
            </div>
        </div>
    );
}

export default FirmFYIConfig;
